import { SET_SITE } from '../constants/actionTypes';

const site = (state = null, action) => {
  switch (action.type) {
    case SET_SITE:
      return { ...action.payload };
    default:
      return state;
  }
};

export default site;



// WEBPACK FOOTER //
// ./src/redux/site.js